// extracted by mini-css-extract-plugin
export default {"actions":"RestrictedDomain_actions__eEG0t","host":"RestrictedDomain_host__t4hpe"};